"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const store_1 = require("@completeanatomy/store");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const hocs_1 = require("../../hocs");
const molecules_1 = require("../../molecules");
const StoreTrialPanel_1 = __importDefault(require("../../molecules/StoreTrialPanel"));
const organisms_1 = require("..");
const providers_1 = require("../../providers");
const store_2 = require("../../utils/store");
const react_1 = require("react");
const react_router_1 = require("react-router");
const styled_components_1 = __importDefault(require("styled-components"));
// import { useMainMenuContext } from 'providers/MainMenuProvider';
// import { selectMenuItem } from 'hooks/reducers/useMainMenuReducer';
const DEFUALT_LICENSES = {
    studentPlus: {
        isPurchased: false,
        isRecommended: false,
        type: bridge_schema_1.LicenseType.StudentPlus,
    },
    pro: {
        isPurchased: false,
        isRecommended: false,
        type: bridge_schema_1.LicenseType.Pro,
    },
    educator: {
        isPurchased: false,
        isRecommended: false,
        type: bridge_schema_1.LicenseType.Edu,
    },
};
// eslint-disable-next-line max-lines-per-function
function MainScreen() {
    //TODO: Legacy. Need to impl navigation later.
    //const [, dispatch] = useMainMenuContext();
    const { isWindows } = (0, device_1.usePlatform)();
    const isCN = (0, device_1.useIsCNRegion)();
    const navigate = (0, react_router_1.useNavigate)();
    const bridge = (0, bridge_1.useBridge)();
    const inappStoreService = (0, providers_1.useInappStoreService)();
    const currentUser = (0, user_1.useUser)();
    const { licenses } = (0, store_1.useStoreState)();
    const { t } = (0, i18n_1.useTranslation)();
    (0, ui_1.usePageTitle)(t(i18n_1.Strings.menu.store));
    const licensesState = licenses !== null && licenses !== void 0 ? licenses : DEFUALT_LICENSES;
    const onShowMore = (0, react_1.useCallback)(() => {
        // @ts-ignore - @todo replace
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: window.STORE_SHOW_MORE_URL });
    }, [bridge]);
    const onClose = () => {
        //dispatch(selectMenuItem(null));
        navigate(-1);
    };
    const onSelectPlan = (license) => {
        if (isWindows) {
            let link = '';
            switch (license.type) {
                case bridge_schema_1.LicenseType.StudentPlus:
                    link = 'https://store.3d4medical.com/checkout/student?promo=windows';
                    break;
                case bridge_schema_1.LicenseType.Pro:
                    link = 'https://store.3d4medical.com/checkout/pro?promo=windows';
                    break;
                default:
                    break;
            }
            if (isCN) {
                link = link.replace('3d4medical.com', 'completeanatomy.cn');
            }
            bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link });
            return;
        }
        if (license === null || license === void 0 ? void 0 : license.product) {
            if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier)) {
                //@ts-ignore -- navigates back to store page.
                window.navigateBack = true;
            }
            inappStoreService === null || inappStoreService === void 0 ? void 0 : inappStoreService.sendSubscriptionAddedToCartEvent(license === null || license === void 0 ? void 0 : license.product);
            // @ts-ignore
            window.Manager.InAppPurchaseManager.purchaseProductWithOptions({
                productIdentifier: license.product.identifier,
            });
        }
    };
    const licenseForType = (licenseType) => {
        switch (licenseType) {
            case bridge_schema_1.LicenseType.StudentPlus:
                return licensesState.studentPlus;
            case bridge_schema_1.LicenseType.Pro:
                return licensesState.pro;
            case bridge_schema_1.LicenseType.Edu:
                return licensesState.educator;
        }
    };
    const sortedLicenses = store_2.SUBSCRIPTION_LICENSE_TYPES.map((licenseType) => licenseForType(licenseType));
    return ((0, jsx_runtime_1.jsx)(ui_1.ModalProvider, { backgroundComponent: ui_1.ModalBackground, "data-e2e": 'MainScreen_ModalProvider', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MainScreen_Container', children: [(0, jsx_runtime_1.jsx)(ui_1.Header, { type: ui_1.HeaderType.WithCloseButton, closeButton: { onClick: onClose, style: { width: '40px' } }, "data-e2e": 'MainScreen_Header', children: (0, i18n_1.Localized)(i18n_1.Strings.store.title) }), (0, jsx_runtime_1.jsx)(ScrollContainer, { "data-e2e": 'MainScreen_ScrollContainer', children: (0, jsx_runtime_1.jsxs)(ScrollContent, { "data-e2e": 'MainScreen_ScrollContent', children: [(0, jsx_runtime_1.jsx)(StoreTrialPanel_1.default, { "data-e2e": 'MainScreen_StoreTrialPanel' }), (0, jsx_runtime_1.jsx)(organisms_1.LicensesPanel, { licenses: sortedLicenses, "data-e2e": 'MainScreen_LicensesPanel' }), (0, jsx_runtime_1.jsx)(molecules_1.PlansTable, { benefits: store_2.STORE_LICENSE_BENEFITS, licenses: sortedLicenses, onSelect: onSelectPlan, "data-e2e": 'MainScreen_PlansTable' }), (0, jsx_runtime_1.jsx)(molecules_1.FeaturesPanel, { "data-e2e": 'MainScreen_FeaturesPanel' }), (0, jsx_runtime_1.jsx)(ui_1.NewWindowButton, { onClick: onShowMore, text: t(i18n_1.Strings.store.showMore), "data-e2e": 'MainScreen_NewWindowButton' }), (0, jsx_runtime_1.jsx)(StyledPrivacyLinks, { "data-e2e": 'MainScreen_StyledPrivacyLinks' })] }) })] }) }));
}
exports.default = (0, hocs_1.withInappStoreProvider)(MainScreen);
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  z-index: 1;

  background: ${({ theme }) => theme.background};
`;
const ScrollContainer = styled_components_1.default.div `
  max-height: calc(100vh - ${props => props.theme.headerHeight}px);

  background: ${props => props.theme.background};
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const ScrollContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 100%;
  height: 100%;
`;
const StyledPrivacyLinks = (0, styled_components_1.default)(ui_1.PrivacyLinks) `
  justify-content: center;
  align-self: center;
  margin: 1em 0 4em 0;
`;
